/** Page size the BFF applies when none is sent (its maximum is 50). */
export const DEFAULT_PAGE_SIZE = 20;

/** `page` is 0-based. */
export type PageRequest = {
  page?: number;
  size?: number;
};

/** MED-1752: filters of an appointment list, applied by the API across all pages. */
export type AppointmentListFilters = {
  search?: string;
  status?: string;
  type?: string;
  date?: string;
};

/** A page of a list, `total` being the count of every item on the server. */
export type Page<T> = {
  items: T[];
  total: number;
};
